import { configurationSettings } from '../../../../configuration';
import { getMonetaryValueWithZeroTax, isZeroMonetaryValue } from '../../../../utils/monetary-value-utils';
import { OrderTipSelectionType } from '../../types/order-tip-selection-type';
import { getOrderTippableItemsTotalPrice } from '../items';
import { getOrderTipSelection } from './get-order-tip-selection';
import { calculateTipAmountForPercentage } from './utils/calculate-tip-amount-for-percentage';
/**
 * Gets the amount of the order tip.
 */
export const getOrderTip = () => {
    if (!configurationSettings.data.order.tip.isEnabled)
        return undefined;
    const tippableTotalPrice = getOrderTippableItemsTotalPrice();
    if (isZeroMonetaryValue(tippableTotalPrice))
        return undefined;
    const tip = getOrderTipSelection();
    if (!tip)
        return undefined;
    switch (tip.type) {
        case OrderTipSelectionType.Percentage:
            return calculateTipAmountForPercentage(tippableTotalPrice, tip.percentage);
        case OrderTipSelectionType.Amount:
            return getMonetaryValueWithZeroTax(tip.amount);
        default:
            throw new Error(`Cannot get order tip amount. Unsupported tip type: ${tip.type}.`);
    }
};
//# sourceMappingURL=get-order-tip.js.map